






























import Vue from 'vue'
import { oneOf } from '@/utils/helper'
import LoadingDot from '@/components/shared/atoms/LoadingDot'

export default Vue.extend({
  components: {
    LoadingDot
  },
  props: {
    candidates: {
      type: Array as () => string[],
      default: () => []
    },
    type: {
      type: String,
      default: 'text',
      validator: oneOf(['text', 'search', 'tel', 'email', 'date', 'password', 'url', 'time', 'number', 'file'])
    },
    placeholder: {
      type: String,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    minlength: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    listId: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    pattern: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    errors: {
      type: Array as () => string[],
      default: () => []
    },
    outputType: {
      type: String,
      default: 'string',
      validator: oneOf(['string', 'number'])
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasCandiates(): boolean {
      return this.candidates.length > 0
    },
    disableAutocomplete(): boolean {
      return this.hasCandiates || this.type === 'password'
    },
    hasError(): boolean {
      return this.errors.length > 0
    },
    inputListeners(): Record<string, Function | Function[]> {
      const vm = this
      const data = {
        ...this.$listeners,
        input(e: { target: { value: string } }) {
          vm.handleInput(vm, e.target.value)
        }
      }
      return data
    }
  },
  methods: {
    numerify(val: string | null): number | null {
      return val === null ? null : Number(val)
    },
    handleInput<T extends Vue>(vm: T, value: string) {
      const trim = value.trim()
      vm.$emit('input', this.outputType === 'number' ? this.numerify(trim) : trim)
    }
  }
})
